import { getProd } from '@figure/frontlib-onboarding-redux';

// TODO: determine if this works with www?
export const baseUrl = () => `wss://${getProd() ? '' : 'test.'}figure.com`;
export const SOCKET_OPEN = 'SOCKET_OPEN';
export const SOCKET_MESSAGE = 'SOCKET_MESSAGE';
export const SOCKET_CLOSE = 'SOCKET_CLOSE';
export const SOCKET_ERROR = 'SOCKET_ERROR';
